// WelcomeModal.js — the first thing a newly-registered teacher sees on the
// dashboard. Orients them to the seeded sample class and offers a guided tour.
// Shown once (gated by a per-uid localStorage flag in Dashboard.js).

import React from "react";
import logo from "../../images/logo.svg";
import "./WelcomeModal.css";

const FEATURES = [
  { icon: "🚪", label: "Sign students out" },
  { icon: "✅", label: "Take attendance" },
  { icon: "🚨", label: "Run a drill" },
  { icon: "📚", label: "Lend books & devices" },
];

export default function WelcomeModal({ teacherName, onExplore, onStartTour }) {
  const first = (teacherName || "").trim().split(" ")[0];

  return (
    <div className="welcome-overlay" role="dialog" aria-modal="true">
      <div className="welcome-card">
        <img src={logo} className="welcome-logo" alt="classBOON" />
        <h2 className="welcome-title">
          Welcome to ClassBoon{first ? `, ${first}` : ""}! 👋
        </h2>
        <p className="welcome-sub">
          We've set up a <strong>sample class</strong> — with students, sign-out
          history, attendance and more — so you can try everything right now. No
          roster to import first.
        </p>

        <div className="welcome-features">
          {FEATURES.map((f) => (
            <div key={f.label} className="welcome-feature">
              <span className="welcome-feature-icon">{f.icon}</span>
              <span>{f.label}</span>
            </div>
          ))}
        </div>

        <div className="welcome-actions">
          <button className="welcome-primary" onClick={onStartTour}>
            Take a quick tour
          </button>
          <button className="welcome-secondary" onClick={onExplore}>
            Explore on my own
          </button>
        </div>

        <p className="welcome-foot">
          When you're ready for your real students, remove the sample with one
          click from its card.
        </p>
      </div>
    </div>
  );
}
